import * as moment from 'moment';

export const convertTimeStampToDate = (timeStampDate) => {
  if (timeStampDate) {
    return moment(timeStampDate).format(
      timeStampDate.length > 10 ? 'Do MMM YYYY, h:mm a' : 'Do MMM YYYY',
    );
    // return moment(timeStampDate).format('MMMM d, yyyy, h:mm a');
  } else {
    return '';
  }
};

export const formatTimepicker = (time, field) => {
  if (time) {
    let isShow24Hours =
      field.extraFieldSetting && field.extraFieldSetting.dateDisplayType === '24_HOURS';
    const format = isShow24Hours ? 'HH:mm' : 'h:mm a';
    return moment(time, format).format(format);
  } else {
    return '';
  }
};
